import { SvgIcon, SvgIconProps } from '@mui/material';
import styles from './ccf-wem-coaching-icon.module.scss';

/* eslint-disable-next-line */
export interface CcfWemCoachingIconProps extends SvgIconProps {}

/**
 * Component used to render WEM Coaching tab Icon
 * @example
 */
export function CcfWemCoachingIcon(props: CcfWemCoachingIconProps) {
  return (
    <SvgIcon {...props} width="21" height="20" viewBox="0 0 21 20" fill="none">
      <path
        d="M6.59998 7.2C7.19998 7.2 7.69998 7.4 8.19998 7.7C8.39998 7.8 8.59998 8 8.79998 8.2C9.39998 8.9 9.69998 9.7 9.69998 10.5C9.69998 11.1 9.49998 11.7 9.19998 12.3C8.99998 12.6 8.79998 12.9 8.49998 13.1L7.59998 13.9L8.69998 14.4C9.49998 14.7 10.1 15.1 10.6 15.8C10.9 16.1 11.1 16.6 11.3 17.1C11.5 17.6 11.1 18.1 10.6 18.1H2.79998C2.29998 18.1 1.89998 17.6 2.09998 17.1C2.29998 16.7 2.49998 16.2 2.79998 15.8C3.29998 15.2 3.89998 14.7 4.59998 14.4L5.69998 14L4.79998 13.3C4.49998 13.1 4.29998 12.8 4.09998 12.5C3.79998 12 3.59998 11.3 3.59998 10.7C3.59998 9.9 3.89998 9 4.49998 8.4C4.99998 7.5 5.79998 7.2 6.59998 7.2ZM6.59998 5.2C5.19998 5.2 3.89998 5.8 2.99998 6.8C2.09998 7.8 1.49998 9.1 1.59998 10.5C1.59998 11.4 1.89998 12.4 2.39998 13.3C1.89998 13.6 1.49998 14 1.19998 14.5C0.89998 14.9 0.59998 15.5 0.29998 16.2C-0.10002 17 -2.04742e-05 18 0.49998 18.7C0.99998 19.5 1.89998 19.9 2.79998 19.9H10.5C11.4 19.9 12.3 19.5 12.8 18.7C13.3 18 13.4 17 13.1 16.2C12.8 15.5 12.5 14.9 12.2 14.4C11.8 13.9 11.4 13.6 11 13.3C11.5 12.4 11.8 11.4 11.8 10.5C11.8 9.2 11.3 7.9 10.4 6.9C9.99998 6.5 9.69998 6.2 9.29998 6C8.49998 5.5 7.59998 5.2 6.59998 5.2Z"
        fill="#7D3CC8"
      />
      <path
        d="M20.2 1C20.2 0.4 19.8 0 19.2 0H2.29998C1.69998 0 1.29998 0.4 1.29998 1C1.29998 1.6 1.69998 2 2.29998 2H3.19998V4C3.19998 4.6 3.59998 5 4.19998 5C4.79998 5 5.19998 4.6 5.19998 4V2H17.2V11H13.1C12.5 11 12.1 11.4 12.1 12C12.1 12.6 12.5 13 13.1 13H13.9L16.4 19.4C16.6 19.8 16.9 20 17.3 20C17.4 20 17.5 20 17.7 19.9C18.2 19.7 18.5 19.1 18.3 18.6L16.1 13H17.6C18.1 13 18.6 12.8 18.9 12.4C19.4 11.8 19.3 11.1 19.2 10.8V2C19.8 2 20.2 1.6 20.2 1Z"
        fill="#7D3CC8"
      />
    </SvgIcon>
  );
}

export default CcfWemCoachingIcon;
